export const UPDATE_EXISTING = "Update existing"
export const CREATE_NEW = "Create New"

export const UPDATE_EXISITING_VISITING_CARD = "Update existing visiting card"
export const CREATE_NEW_VISITING_CARD = "Create new visiting card"

export const VISITING_CARD = "E-Visiting Card"
export const DIGITAL_CARD = "DigiCard"